<template>
    <button
        class="border font-medium shadow-sm focus:outline-none transition duration-150 ease-in-out"
        :class="[themeClass, sizeClass]">
        <slot></slot>
    </button>
</template>

<script>

export default {

    props: {
        theme: {
            type: String,
            default: 'primary'
        },
        size: {
            type: String,
            default: 'md'
        }
    },

    computed: {
        themeClass() {
            return {
                'primary': `
                    border-transparent text-teal-dark bg-green hover:bg-green-light
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600
                    active:bg-green-dark
                `.replace(/\s\s+/g, ' ').trim(),
                'plain': `
                    py-2 px-3 border border-gray-300 text-sm leading-4 font-medium text-gray-700
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600
                    hover:text-gray-500
                    active:bg-gray-50 active:text-gray-800
                    transition duration-150 ease-in-out
                `.replace(/\s\s+/g, ' ').trim()
            }[this.theme];
        },
        sizeClass() {
            return {
                'md': 'py-2 px-4 text-sm leading-5 rounded-full',
            }[this.size];
        },
    }
};

</script>
